// 템플릿 복제(모든 언어) / 내용 가져오기(현재 언어만) 순수 헬퍼.
// node:test + webpack 양쪽 사용을 위해 CommonJS 로 작성.

// 본문/제목 원본에 스니펫 참조가 있으면 렌더된(펼친) flat 텍스트를 편집 대상으로 쓴다.
const SNIPPET_REF_RE = /\{\{?%\s*snippet\s+/;

// /full 응답에서 편집용 flat 텍스트를 뽑는다.
function flatOf(rawText, renderedText) {
    if (rawText && SNIPPET_REF_RE.test(rawText)) return renderedText || rawText || '';
    return rawText || '';
}

// /full 콘텐츠 → 편집기 탭 1개.
function toEditorContent(c) {
    return {
        locale: c.locale,
        is_default: !!c.is_default,
        subject: flatOf(c.subject_text, c.subject_rendered),
        body: flatOf(c.body_text, c.body_rendered),
        _sourceMode: false,
    };
}

// 내용 가져오기: 같은 언어만. 없으면 null — 기본 언어로 대체하지 않는다(ko 가 en 탭에 조용히 들어가던 버그).
function pickSameLocale(srcContents, locale) {
    return (srcContents || []).find(c => c.locale === locale) || null;
}

// 템플릿 복제: /full 응답 → 새 템플릿 편집 폼. 모든 언어·발송 상황·조건·기본 여부를 그대로 옮긴다.
function buildDuplicateForm(full) {
    const d = full || {};
    const contents = (d.contents || []).map(toEditorContent);
    if (!contents.length) contents.push({ locale: 'ko', is_default: true, subject: '', body: '', _sourceMode: false });
    return {
        label: `${d.label || ''} (복사본)`,
        scenario_code: d.scenario_code || '',
        isFallback: !!d.is_fallback,
        contexts: { ...(d.contexts || {}) },
        contents,
    };
}

// 저장 시 "조건이 겹치는 템플릿이 이미 있다" 응답 해석. 충돌이 아니면 null.
// 신: 409 { error, conflict_template_id, conflict_template_label, detail? }
// 구: 400 평문 "컨텍스트 겹침 감지! 기존 템플릿 ID:N (라벨)와 충돌합니다.\n충돌 항목: ..."
//     409 평문 "Duplicate template id=N"
const OVERLAP_RE = /ID\s*:\s*(\d+)\s*\((.*?)\)\s*와\s*충돌/;
const DUPLICATE_RE = /Duplicate template id\s*=\s*(\d+)/i;

function parseTemplateConflict(status, data) {
    let id = null;
    let label = '';
    let detail = '';
    if (data && typeof data === 'object' && data.conflict_template_id != null) {
        id = Number(data.conflict_template_id);
        label = data.conflict_template_label || '';
        detail = data.detail || '';
    } else {
        const text = data == null ? '' : String(typeof data === 'object' ? (data.error || data.message || '') : data);
        const overlap = status === 400 && text.includes('겹침') ? OVERLAP_RE.exec(text) : null;
        const dup = status === 409 ? DUPLICATE_RE.exec(text) : null;
        if (overlap) {
            id = Number(overlap[1]);
            label = overlap[2].trim();
            detail = text.split('\n').slice(1).join('\n').trim();
        } else if (dup) {
            id = Number(dup[1]);
        } else if (status === 409) {
            // 409 인데 형식을 모르면 id 없이 안내만.
            return { id: null, label: '', detail: '', message: conflictMessage(null, '') };
        } else {
            return null;
        }
    }
    if (!Number.isFinite(id)) id = null;
    return { id, label, detail, message: conflictMessage(id, label) };
}

function conflictMessage(id, label) {
    const who = id != null ? `: #${id}${label ? ` ${label}` : ''}` : '';
    return `조건이 겹치는 템플릿이 이미 있습니다${who}. 발송 상황이나 조건을 바꿔 저장하세요.`;
}

module.exports = {
    flatOf,
    toEditorContent,
    pickSameLocale,
    buildDuplicateForm,
    parseTemplateConflict,
};
